/* eslint-disable react/prop-types */
import { useMergeRefs } from '@floating-ui/react';
import { AuthorizationWrapper, Permission } from '@frontend/authorization';
import { ClassType } from '@frontend/common';
import React from 'react';
import { IconType } from 'react-icons';

import useDropdownItem from './dropdown-item.controller';

const ID = 'dropdown-item';
export interface DropdownItemProps {
    label: React.ReactNode;
    disabled?: boolean;
    classType?: ClassType;
    icon?: IconType;
    requiredPermissions?: Permission[];
    hide?: boolean | (() => boolean);
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
}

export const DropdownItem = React.forwardRef<HTMLButtonElement, DropdownItemProps & React.ButtonHTMLAttributes<HTMLButtonElement>>(function item(
    { label, disabled, ...props },
    forwardedRef
) {
    const viewProps = useDropdownItem();
    if (typeof props.hide === 'function' ? props.hide() : props.hide) {
        return null;
    }
    if (props.requiredPermissions) {
        return (
            <AuthorizationWrapper requiredPermissions={props.requiredPermissions}>
                <button
                    {...props}
                    ref={useMergeRefs([viewProps.item.ref, forwardedRef])}
                    id={ID}
                    type='button'
                    role='menuitem'
                    className='dropdown-item d-flex align-items-center'
                    tabIndex={viewProps.isActive ? 0 : -1}
                    disabled={disabled}
                    {...viewProps.menu.getItemProps({
                        onClick(event: React.MouseEvent<HTMLButtonElement>) {
                            props.onClick?.(event);
                            viewProps.tree?.events.emit('click');
                        },
                        onFocus(event: React.FocusEvent<HTMLButtonElement>) {
                            props.onFocus?.(event);
                            viewProps.menu.setHasFocusInside(true);
                        }
                    })}>
                    <span className={`d-flex align-items-center justify-content-start w-100 flex-row px-3 py-1 ${viewProps.isActive && `bg-light`}`}>
                        <span className='btn-inner--icon'>{props.icon && <props.icon className={`text-${props.classType || 'primary'} me-2`} />}</span>
                        <span>{label}</span>
                    </span>
                </button>
            </AuthorizationWrapper>
        );
    }

    return (
        <button
            {...props}
            ref={useMergeRefs([viewProps.item.ref, forwardedRef])}
            id={ID}
            type='button'
            role='menuitem'
            className='dropdown-item d-flex align-items-center'
            tabIndex={viewProps.isActive ? 0 : -1}
            disabled={disabled}
            {...viewProps.menu.getItemProps({
                onClick(event: React.MouseEvent<HTMLButtonElement>) {
                    props.onClick?.(event);
                    viewProps.tree?.events.emit('click');
                },
                onFocus(event: React.FocusEvent<HTMLButtonElement>) {
                    props.onFocus?.(event);
                    viewProps.menu.setHasFocusInside(true);
                }
            })}>
            <span className={`d-flex align-items-center justify-content-start w-100 flex-row px-3 py-1 ${viewProps.isActive && `bg-light`}`}>
                <span className='btn-inner--icon'>{props.icon && <props.icon className={`text-${props.classType || 'primary'} me-2`} />}</span>
                <span className={props.className}>{label}</span>
            </span>
        </button>
    );
});

export default DropdownItem;
